import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/jensen'

Styxie.Initializers.JensenPhoneNumbers = {
  index: async(props) => {
    const { default: PhoneNumbersIndex } = await import('@/vue_widgets/jensen/phone_numbers/index.vue')
    createVueApp(PhoneNumbersIndex, { props, sidebar })
  },

  new: async(props) => {
    const { default: PhoneNumbersNew } = await import('@/vue_widgets/jensen/phone_numbers/new.vue')
    createVueApp(PhoneNumbersNew, { props, sidebar })
  },

  edit: async(props) => {
    const { default: PhoneNumbersEdit } = await import('@/vue_widgets/jensen/phone_numbers/edit.vue')
    createVueApp(PhoneNumbersEdit, { props, sidebar })
  }
}
